import React from 'react';
import Icon from '@Components/Icon/Icon';
import { useDispatch } from 'react-redux';
import useTranslate from '@Utils/hooks/useTranslate';
import { modalTypes, setModal } from '@Redux/modules/modal/actions';
import EditCTA from './EditCTA';
import {
	HeaderDescriptionWrapper,
	HeaderTitle,
	HeaderWrapper,
} from '@Components/Card/cards/ShippingDetails/ShippingDetails.styled';

const Title = ({
	showEdit,
	showOrder,
	isSimplifiedCheckout,
}: {
	showEdit: boolean;
	showOrder: boolean;
	isSimplifiedCheckout: boolean;
}): JSX.Element => {
	const { translate } = useTranslate();
	const dispatch = useDispatch();

	const openAddressList = () => {
		dispatch(
			setModal({
				type: modalTypes.SHIPPING_ADDRESS,
				data: {},
				withoutContainer: true,
			})
		);
		return false;
	};

	return (
		<HeaderWrapper>
			<Icon name={showOrder ? 'order' : 'shipping'} fill="black38" width={40} height={40} />
			<HeaderDescriptionWrapper>
				<HeaderTitle>
					{showOrder
						? translate('order-details.title')
						: isSimplifiedCheckout
						? translate('secure-checkout.shipping-address.title')
						: translate('shipping-details.title')}
				</HeaderTitle>
			</HeaderDescriptionWrapper>
			{showEdit && <EditCTA onClick={openAddressList} uniqueId="openAddressList" />}
		</HeaderWrapper>
	);
};

export default Title;
